// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1Ahng","assignButton":"CreateEditEquipmentSchedule_assignButton__1Y9Uu"};